
export default function returnDiscountedAmount({cost, discount, discountType}) {
    try {
        if(discountType === 'flat') {
            return Number((+cost - +discount).toFixed(2))
        } else {
            let newDiscount = cost * (discount / 100)
            return Number((+cost - +newDiscount).toFixed(2))
        }
    } catch (error) {
        throw error
    }
}